import imageDog from '../../../assets/image/snail-looking-for.png'
import ButtonCreateCampaigns from '../../atoms/buttonCreateCampaigns'
import css from './NoCampaignsYetTemplate.module.scss'
export function NoCampaignsYetTemplate() {
	return (
		<article className={css.body}>
			<span className='h-2 title'>Ready to start?</span>
			<img alt='snail' className={css.pic} src={imageDog} width={150} />
			<p>
				No campaigns yet. <br />
				Create your first campaign to get more leads on LinkedIn
			</p>
			<ButtonCreateCampaigns
				classes='btn-v1 semi-bold'
				text='Create now'
				type='new'
			/>
		</article>
	)
}
